<template>
  <v-form v-model="valid" ref="mainForm">
    <DatePickerLive code="stage_debut" v-model="sasStage.datePrevuDeDebut" :live="liveSasStage(6506)" />
    <CatalogueLive
      code="stage_type_etablissement"
      v-model="sasStage.typeDEtablissementDAccueil"
      :live="liveSasStage(6502)"
      :filter="(fd) => fd.value === $valeursCatalogues.pharmacieCommunautaire || fd.value === $valeursCatalogues.etablissementSante"
    />
    <div>
      <SearchOrganisation
        v-if="!organisation"
        :rules="[(v) => !!organisation || 'Veuillez sélectionner un établissement']"
        @organisation-selected="organisationSelected"
        isStage
      />
      <div v-if="organisation">
        <ressource code="etablissement" class="caption" />
        <v-card class="px-6 pt-3 mb-3" outlined max-width="450">
          <div class="text-right">
            <v-btn icon @click="clearOrganisation"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <h3>{{ organisation.organisation }}</h3>
          <p>{{ organisation.codePostal }}</p>
        </v-card>
      </div>
    </div>

    <CatalogueLive code="stage_type" v-model="sasStage.typeDeStage" :live="liveSasStage(6505)" />

    <div>
      <SearchPharmacien
        v-if="!maitreStage"
        :rules="[(v) => !!maitreStage || 'Veuillez sélectionner un maitre de stage']"
        @pharmacien-selected="pharmacienSelected"
      />
      <div v-if="maitreStage">
        <ressource code="maitre_de_stage" class="caption" />
        <v-card class="px-6 pt-3 mb-3" outlined max-width="450">
          <div class="text-right">
            <v-btn icon @click="clearMaitreStage"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <h3>{{ maitreStage.fullName }}</h3>
          <p>{{ maitreStage.licenseNumber }}</p>
        </v-card>
      </div>
    </div>
    <FileInput code="stage_formulaire" :file="sasStage.formulaireSigneMaitreStage" :live="liveSasStage(6507)" />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import SearchOrganisation from "@/components/Common/SearchOrganisation.vue"
import SearchPharmacien from "@/components/Common/SearchPharmacien.vue"
import { Queue, Api } from "@/plugins/api"
export default {
  mixins: [StepFormWithValidation],
  components: {
    SearchOrganisation,
    SearchPharmacien
  },
  data() {
    return {
      organisation: null,
      maitreStage: null
    }
  },
  props: {
    sas: { type: Object }
  },
  mounted() {
    this.organisation = this.sasStage.etablissement
    this.maitreStage = this.sasStage.maitreDeStage
  },
  computed: {
    sasStage() {
      return this.sas.sasStage
    }
  },
  methods: {
    liveSasStage(cle) {
      return { endpoint: "sas-stages", cle: cle, fileId: this.sasStage.id }
    },
    clearOrganisation() {
      Queue.enqueue(() =>
        Api.post("sas-stages", {
          fileId: this.sasStage.id,
          cle: "6503",
          value: null
        }).then(() => {
          this.organisation = null
        })
      )
    },
    organisationSelected(organisation) {
      Queue.enqueue(() =>
        Api.post("sas-stages", {
          fileId: this.sasStage.id,
          cle: "6503",
          value: organisation.organisationId
        }).then(() => {
          this.organisation = organisation
        })
      )
    },
    clearMaitreStage() {
      Queue.enqueue(() =>
        Api.post("sas-stages", {
          fileId: this.sasStage.id,
          cle: "6504",
          value: null
        }).then(() => {
          this.maitreStage = null
        })
      )
    },
    pharmacienSelected(pharmacien) {
      Queue.enqueue(() =>
        Api.post("sas-stages", {
          fileId: this.sasStage.id,
          cle: "6504",
          value: pharmacien.id
        }).then(() => {
          this.maitreStage = pharmacien
        })
      )
    }
  }
}
</script>